/**
 * Labstep
 *
 * @module components/ResourceTemplate/Table
 * @desc Table component for displaying resource templates.
 */

import { EntityLink } from 'labstep-web/components/Entity/Link';
import { EntityTableParamsContainer as EntityTable } from 'labstep-web/components/Entity/Table';
import {
  Action,
  ResourceTemplateActionMenu,
} from 'labstep-web/components/ResourceTemplate/Action/Menu';
import type { Resource } from 'labstep-web/models/resource.model';
import type React from 'react';
import type { IResourceTemplateTableProps } from './types';

export const ResourceTemplateTable: React.FC<
  IResourceTemplateTableProps
> = ({ resourceTemplates, ...rest }) => {
  return (
    <EntityTable
      id="resource-category-table"
      entities={resourceTemplates}
      primaryColumn={{
        header: 'Name',
        content: (resource: Resource) => (
          <EntityLink entity={resource} />
        ),
        cellProps: { style: { flex: 3 } },
      }}
      actionMenu={({ entity }) => (
        <ResourceTemplateActionMenu
          resourceTemplate={entity as Resource}
          actions={[
            Action.share,
            Action.duplicate,
            Action.transfer_ownership,
            Action.delete,
          ]}
        />
      )}
      {...rest}
    />
  );
};
